<template>
    <div class="bottom-operate-bar">
        <div>
            <RoundButton class="offline-btn" :text="offlineLabel" @btnClick="offlineSave" />
            <RoundButton class="online-btn" :icon="onlineIcon" :text="onlineLabel" @btnClick="onlineClick" />
        </div>
        <div>
            <RoundButton class="delete-btn" v-show="data.status !== 'online'" :text="deleteLabel" @btnClick="deleteClick" />
        </div>
    </div>
</template>

<script>
import RoundButton from "@/views/zhiji/bComponents/buttons/RoundButton";
import i18n from "@/i18n";

export default {
    name: "BottomOperateBar",
    props: ["data"],
    components: {
        RoundButton
    },
    computed: {
        offlineLabel() {
            return this.$t("zhiji.knowlege.offline");
        },
        deleteLabel() {
            return this.$t("zhiji.common.delete");
        },
        onlineLabel() {
            return this.$t("zhiji.knowlege.online");
        },
        onlineIcon() {
            if (this.getStorePorp("isUpdating") === "success") {
                this.$nextTick(() => {
                    this.showSuccessTip(this.$t("zhiji.knowlege.onlineSucTip"));
                });
            }

            return this.getStorePorp("isUpdating") === "sending" ? this.onlineUrl : "";
        }
    },
    methods: {
        getStorePorp(propName) {
            return this.$store.state.zhiji.sensitiveWords[propName];
        },
        offlineSave() {
            this.$store.dispatch("zhiji/showModal", {
                type: "MessageModal",
                data: {
                    type: "tip",
                    message: i18n.t("zhiji.sensitiveWord.offlineConfim"),
                    cancel: () => {},
                    confirm: () => {
                        this.$store.dispatch("zhiji/updateSensitiveGroup", {
                            ...this.data,
                            status: "offline"
                        });
                    }
                }
            });
        },
        deleteClick() {
            this.$store.dispatch("zhiji/showModal", {
                type: "MessageModal",
                data: {
                    type: "tip",
                    message: i18n.t("zhiji.sensitiveWord.delGroupConfim"),
                    cancel: () => {},
                    confirm: () => {
                        this.$store.dispatch("zhiji/updateSensitiveGroup", {
                            ...this.data,
                            deleted: 1
                        });
                    }
                }
            });
        },
        onlineClick() {
            this.onlineUrl = "url(" + this.zhiji.staticPath() + "loading-whrite.gif) 0 0/cover";
            this.$store.dispatch("zhiji/updateSensitiveGroup", {
                ...this.data,
                status: "online"
            });
        },
        showSuccessTip(message) {
            this.$message({
                message: message,
                center: true,
                duration: 2000,
                type: "success"
            });
        }
    }
};
</script>

<style lang="less" scoped>
.bottom-operate-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    box-sizing: border-box;
    padding: 15px 8px 16px 24px;
    border-top: 1px solid #d9e4ef;
    background: #fafbfd;
    .offline-btn,
    .delete-btn {
        border: solid 1px #d8e4f0;
        color: #41475e;
        background: #fff;
        box-shadow: none;
        min-width: 96px;
        padding: 0 16px;
        box-sizing: border-box;
        line-height: 30px;
        &:hover {
            color: #2ec2ff;
        }
    }
}
</style>
